import React from 'react'

import { Typography, Box } from '@vp/swan'

export const TenantError: React.FC<{ heading: string; subtitle: string }> = ({ heading, subtitle }) => {
  return (
    <Box py={11} mx={3} align="center" data-testid="tenant-error">
      <Typography fontSkin="title-section" textAlign="center" py={5}>
        {heading}
      </Typography>
      <Typography fontSize="large" textAlign="center" py={5}>
        {subtitle}
      </Typography>
    </Box>
  )
}
